import { BaseService } from 'core/services';
import CoreUserRouteService from './CoreUserRouteService';

class CoreUserService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new CoreUserRouteService());
    }

    updateUserSetting(resource) {
        const url = this.routeService.updateUserSetting(resource);
		return this.apiClient.put(url, resource);
    }
}

export default CoreUserService;
